export enum DebitType {
  Unit = 'unit',
  Weekly = 'weekly',
  Monthly = 'monthly',
  OneTime = 'oneTime',
  Ongoing = 'ongoing',
}

export const DebitTypeTranslationForSum: Record<DebitType, string> = {
  [DebitType.Unit]: 'tillfälle',
  [DebitType.Weekly]: 'vecka',
  [DebitType.Monthly]: 'månad',
  [DebitType.OneTime]: 'gång',
  [DebitType.Ongoing]: 'tim',
};
